import WidgetContainer from './WidgetContainer';
import ActionButton from './ActionButton';
import { ActionDef, useConversation } from '@chewy/chat-library-common';
import { ChirpIllustration } from '@chewy/chirp-media-kit';
import '@chewy/chirp-media-kit/illustration/styles.css';
import styles from './AddPetCard.module.scss';
import { toChirpEnv } from './utils/env';

export default function AddPetCard({ action, widgetData }: { action: ActionDef; widgetData?: Record<string, any> }) {
  const { env } = useConversation();

  return (
    <WidgetContainer isSelectable={false} hasActions containerStyle={{ width: '254px', maxWidth: '100%' }}>
      <div className={styles.container}>
        <ChirpIllustration className={styles.illustration} name="illo-smallspot-addapet" env={toChirpEnv(env)} isDecorative={false} aria-label="Add a pet" />
        <ActionButton action={action} widgetData={widgetData} />
      </div>
    </WidgetContainer>
  );
}
